var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5198 8.02C10.6136 8.11368 10.6663 8.24077 10.6665 8.37334V8.62667C10.6649 8.75895 10.6124 8.88552 10.5198 8.98L7.09312 12.4C7.03053 12.4631 6.94533 12.4986 6.85645 12.4986C6.76757 12.4986 6.68237 12.4631 6.61978 12.4L6.14645 11.9267C6.08374 11.8652 6.0484 11.7811 6.0484 11.6933C6.0484 11.6055 6.08374 11.5214 6.14645 11.46L9.11312 8.5L6.14645 5.54C6.08335 5.47741 6.04785 5.39222 6.04785 5.30334C6.04785 5.21446 6.08335 5.12926 6.14645 5.06667L6.61978 4.6C6.68237 4.5369 6.76757 4.5014 6.85645 4.5014C6.94533 4.5014 7.03053 4.5369 7.09312 4.6L10.5198 8.02Z",
    fill: "#758196"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.d45ab198dc567f98e01c3fce0c2ff95a.svg";
export { ForwardRef as ReactComponent };